<template>
  <div class="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900 overflow-x-hidden">
    <AppHeader v-if="showHeader" />
    <main class="flex-1">
      <RouterView />
    </main>
    <AppFooter v-if="showFooter" />
    <Toast />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import Toast from '@/components/common/Toast.vue'
import { useToast } from '@/composables/useToast'

const route = useRoute()
const { t } = useI18n()
const { error: showError } = useToast()

const showHeader = computed(() => {
  return !['index', 'login', 'notfound'].includes(route.name as string)
})

const showFooter = computed(() => {
  return !['login', 'notfound'].includes(route.name as string)
})

function handleGlobalError(event: ErrorEvent) {
  console.error('[Global Error]', event.message, event.filename, event.lineno)
  showError(t('common.systemError'))
}

function handleUnhandledRejection(event: PromiseRejectionEvent) {
  console.error('[Unhandled Rejection]', event.reason)
  showError(t('common.systemError'))
}

onMounted(() => {
  window.addEventListener('error', handleGlobalError)
  window.addEventListener('unhandledrejection', handleUnhandledRejection)
})

onUnmounted(() => {
  window.removeEventListener('error', handleGlobalError)
  window.removeEventListener('unhandledrejection', handleUnhandledRejection)
})
</script>
